module.exports = __webpack_public_path__ + "img/摄像头_1.8f9b9583.jpg";